import React, { Component } from "react";
import PropTypes from "prop-types";
import { withFormsy } from "formsy-react";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

class DateTimePicker extends Component {
  handleChange = (date) => {
    this.props.onChange(date, this.props.name);
  };

  render() {
    const {
      name,
      placeholderText,
      value,
      label,
      required,
      disabled,
      showTimeSelect,
      showTimeSelectOnly,
      minTime,
      maxTime
    } = this.props;
    const formattedName = name.replace(/_/g, " ");
    const fieldLabel = required && !disabled ? `${label} *` : label;
    const errorMessage = this.props.getErrorMessage?.();

    const momentObject = value ? moment(moment(value).format("LLL")) : null;

    return (
      <div className="form-group row">
        <label
          className="control-label"
          htmlFor={formattedName}
          style={{ textTransform: "uppercase" }}
        >
          {fieldLabel}
        </label>
        <DatePicker
          selected={momentObject}
          className="form-control"
          onChange={this.handleChange}
          placeholderText={placeholderText || "Enter time"}
          showTimeSelect={showTimeSelect}
          showTimeSelectOnly={showTimeSelectOnly}
          disabled={disabled}
          timeFormat="hh:mm A"
          timeIntervals={15}
          dateFormat={showTimeSelectOnly ? "hh:mm A" : "LLL"}
          timeCaption="Time"
          minTime={minTime}
          maxTime={maxTime}
        />
        {/* {!valid && <span className="validation-message">{errorMessage}</span>} */}
        <span className="validation-message">{errorMessage}</span>
      </div>
    );
  }
}

DateTimePicker.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  placeholderText: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onChange: PropTypes.func,
  required: PropTypes.bool,
  getErrorMessage: PropTypes.func,
  showTimeSelect: PropTypes.bool,
  showTimeSelectOnly: PropTypes.bool,
  minTime: PropTypes.instanceOf(Date),
  maxTime: PropTypes.instanceOf(Date)
};

DateTimePicker.defaultProps = {
  showTimeSelect: true
};

export { DateTimePicker as DateTimePickerWithNoFormsy };

export default withFormsy(DateTimePicker);
